import { setEocReport } from "../set/setEocReport";
import { graphQLFetch } from "../../../utils";
import { GENERATE_EOC_REPORT} from "../../queries";

export const getEocReport =
  ({ companyId, projectId }) =>
  async (dispatch, getState) => {
    if (!companyId || !projectId) {
      throw new Error("companyId and projectId are required to fetch EOC report");
    }

    const data = await graphQLFetch(
      GENERATE_EOC_REPORT,
      { cId: companyId, pId: projectId },
      "query",
      getState
    );

     const { generateEocReport } = data || {};
      if (!generateEocReport || !generateEocReport.base64) {
        console.error("Invalid PDF response:", data);
        throw new Error("Failed to generate BAT report");
      }

    const reportPayload = {
      base64: generateEocReport.base64,
      fileName: generateEocReport.fileName,
      mimeType: generateEocReport.mimeType,
    };

    return dispatch(setEocReport(reportPayload));
  };